import React, {useState} from 'react';
import {
   View,
   Image,
   StyleSheet,
   Dimensions,
   Text,
   TouchableOpacity,
   Alert,
   Platform,
   ImageBackground,
} from 'react-native';
import ModuleSlidesList from './ModuleSlidesList';
import ModuleSlideItem from './ModuleSlideItem';
import {
   courseDetailLowerViewColor,
   couurseDetailButtonColor,
   courseListBGColor,
   appBackground,
   getNavBarHeight,
   drawerListBackgroundColor,
   coureTitleBGGradientColorUpper,
   primaryColor500,
   getStatusBarHeight,
   FONT_FAMILY_REGULAR,
   coureTitleBGGradientColorLower,
   isNewAPI,
   isWeb,
   isHoverEnabled,
   rectifyBooleanString,
   isWindows,
   isMacOS,
} from '../../utils/utils';
import {
   useFocusEffect,
   useIsFocused,
   useNavigation,
} from '@react-navigation/native';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';
//import Svg, {Defs, LinearGradient, Stop, Rect} from 'react-native-svg';
import UISvg from '../../components/svg';
import logger from '../../utils/logger';
import Orientation from 'react-native-orientation-locker';
import {setIsEnrolledPageReload} from '../../redux/slices/EnrolledCourseDataSlice';
import {
   getCurrentPageWithRespectiveModule,
   selectedScratchPadRecord,
} from '../../redux/slices/ScratchPadRecordSlice';
import {selectedModuleIndex} from '../../redux/slices/ModuleIndexSlice';
import {setResponseAlertData} from '../../redux/slices/ResponseAlertSlice';
import {
   selectCommingFromDetails,
   setCommingFromDetails,
} from '../../redux/slices/TrackRoot';
const {width, height} = Dimensions.get('window');

// Button actions
const handleExitAction = () => {
   logger('handleExitAction tapped');
};

const handleResetAction = () => {
   logger('handleResetAction tapped');
};

const handleUnlockAction = () => {
   logger('handleUnlockAction tapped');
};

const Header = ({styles}) => (
   <View style={styles.headerContainer}>
      <Text style={styles.headerTitle}>
         {'Select an available slide to continue progress.'}
      </Text>
   </View>
);

const ModuleSlidesView = props => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const mCommingRoot = useSelector(selectCommingFromDetails);
   const styles = style(isLandscapemode);
   const [courseModuleSlide, setCourseModuleSlide] = useState([]);
   const [isDashBoardRoot, setDashBoardRoot] = useState(true);
   // const courseNameID = props.cModuleSlide.courseNameID;
   const moduleIndex = props.cModuleSlide.moduleIndex; //useSelector(selectedModuleIndex);
   let scratchPadString = useSelector(selectedScratchPadRecord);
   logger('scratchPadStringvvv ', {scratchPadString});
   const scratchPad = JSON.parse(scratchPadString);
   const scratchPadRecord = isNewAPI
      ? scratchPad.ScratchPadRecordsList
      : scratchPad.scratchPadRecord;
   const temSlideNumber = isNewAPI
      ? scratchPadRecord[moduleIndex].ModulePageNumber
      : scratchPadRecord[moduleIndex].PageNumber;
   const currentSlideNumber = temSlideNumber === 0 ? 1 : temSlideNumber;
   const navigation = useNavigation();
   const [rowHeights, setRowHeights] = useState({});
   const dispatch = useDispatch();
   const isWeb = Platform.OS === 'web';
   const isPreTeastEnable = props.cModuleSlide.isPreTeastEnable;
   const isModuleHaveSingleSlide = !Array.isArray(courseModuleSlide);
   if (
      currentSlideNumber === 1 ||
      isPreTeastEnable ||
      isModuleHaveSingleSlide
   ) {
      let temCourseModuleSlide;
      if (!Array.isArray(courseModuleSlide)) {
         temCourseModuleSlide = [courseModuleSlide];
      } else {
         temCourseModuleSlide = props.cModuleSlide.CourseModuleSlide;
      }
      const param = {
         courseModuleID: 0,
         courseModuleSlide: Array.isArray(temCourseModuleSlide)
            ? temCourseModuleSlide
            : [temCourseModuleSlide],
         index: isPreTeastEnable ? temCourseModuleSlide.length - 1 : 0,
         courseData: props.cModuleSlide.courseData,
         courseTitle: props.cModuleSlide.CourseModuleName,
         isPreTeastEnable: isPreTeastEnable,
      };
      if (mCommingRoot) {
         navigation.navigate('PlayerScreen', param);
      }
   }
   const isScreenFocused = useIsFocused();
   useFocusEffect(
      React.useCallback(() => {
         if (isLandscapemode) {
            Orientation.lockToLandscape();
         } else {
            setTimeout(() => {
               Orientation.lockToPortrait();
            }, 500);
         }
      }, []),
   );

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         // logger('DATA1', props.cModuleSlide.CourseModuleSlide);
         if (!Array.isArray(courseModuleSlide)) {
            setCourseModuleSlide([courseModuleSlide]);
         } else {
            setCourseModuleSlide(props.cModuleSlide.CourseModuleSlide);
         }
      }
   }, []);

   const handleCourseSupportAction = () => {
      // navigation.navigate('PlayerScreen', {courseModuleSlide: courseModuleSlide});
      const index = courseModuleSlide.length;

      if (currentSlideNumber < index) {
         navigation.navigate('PlayerScreen', {
            courseModuleID: 0,
            courseModuleSlide: Array.isArray(courseModuleSlide)
               ? courseModuleSlide
               : [courseModuleSlide],
            index: currentSlideNumber === 1 ? 0 : currentSlideNumber - 1,
            courseData: props.cModuleSlide.courseData,
            courseTitle: props.cModuleSlide.CourseModuleName,
         });
      } else if (
         currentSlideNumber == index - 1 ||
         currentSlideNumber >= index
      ) {
         const item = courseModuleSlide[index - 1];
         if (
            rectifyBooleanString(props.cModuleSlide.isModuleComplete) &&
            rectifyBooleanString(item.courseModuleSlideTestSettings.isFinalTest)
         ) {
            Alert.alert('Alert!', 'You have already completed the test', [
               {
                  text: 'OK',
                  onPress: () => {
                     navigation.pop(1);
                  },
               },
            ]);
            if (isWeb) {
               dispatch(
                  setResponseAlertData({
                     showAlert: true,
                     title: 'Alert!',
                     message: 'You have already completed the test.',
                     callbackType: 'GO_BACK',
                  }),
               );
            }
            return;
         } else {
            navigation.navigate('PlayerScreen', {
               courseModuleID: 0,
               courseModuleSlide: Array.isArray(courseModuleSlide)
                  ? courseModuleSlide
                  : [courseModuleSlide],
               index: index - 1,
               courseData: props.cModuleSlide.courseData,
               courseTitle: props.cModuleSlide.CourseModuleName,
            });
         }
      }
   };
   const [isBackHover, setBackHover] = useState(false);
   const [isContinueHover, setContinueHover] = useState(false);

   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     height: '100%',
                     minHeight: '100vh',
                     paddingTop: null,
                  },
               }),
            },
         ]}>
         {/** Back button and navigatin title  */}
         <View
            style={{
               backgroundColor: '#202020',
               ...Platform.select({web: {paddingTop: 16}}),
            }}>
            {!isLandscapemode ? (
               <View
                  style={{
                     flexDirection: 'row',
                     alignItems: 'center',
                     height: isWeb ? '7vh' : getNavBarHeight(),
                     backgroundColor: drawerListBackgroundColor,
                  }}>
                  <TouchableOpacity
                     style={{padding: 10, marginTop: 0, marginLeft: 10}}
                     onPress={() => {
                        props.navigation.goBack();
                     }}>
                     <Image
                        source={require('../../assets/back_arrow.png')}
                        style={{width: 16, height: 16}}
                     />
                  </TouchableOpacity>
                  <Text
                     style={{
                        fontSize: 16,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        color: 'white',
                        marginStart: 21,
                        marginTop: 0,
                        marginRight: '10%',
                     }}>
                     {props.cModuleSlide.CourseModuleName}
                  </Text>
               </View>
            ) : (
               <ImageBackground
                  source={require('../../assets/bg-course-info.png')}
                  imageStyle={{borderRadius: 8}}
                  style={{
                     flexDirection: 'column',
                     height: 120,
                     marginTop: getStatusBarHeight() + 10,
                     marginHorizontal: 24,
                     marginBottom: 16,
                     borderRadius: 8,
                     justifyContent: 'center',
                     // ...Platform.select({
                     //    web: {
                     //       marginLeft: 14,
                     //       marginRight:
                     //          courseModuleSlide.slice(0, currentSlideNumber)
                     //             ?.length > 3
                     //             ? 30
                     //             : 16,
                     //    },
                     // }),
                  }}>
                  <View>
                     <Text
                        style={{
                           fontSize: 24,
                           fontWeight: '700',
                           fontFamily: FONT_FAMILY_REGULAR,
                           color: 'white',
                           marginStart: 21,
                           marginTop: 0,
                        }}>
                        {props.cModuleSlide.CourseModuleName}
                     </Text>
                     <Text
                        style={{
                           fontSize: 16,
                           fontWeight: '400',
                           fontFamily: FONT_FAMILY_REGULAR,
                           color: 'white',
                           marginStart: 21,
                           marginTop: 5,
                           opacity: 0.6,
                        }}>
                        {'Select an available slide to continue progress.'}
                     </Text>
                  </View>
               </ImageBackground>
            )}
         </View>

         <View
            style={{
               flex: 1,
               backgroundColor: '#202020',
               ...Platform.select({
                  web: {
                     paddingBottom: !isLandscapemode ? 80 : null,
                  },
               }),
            }}>
            <ModuleSlidesList
               style={{
                  marginTop: isWeb && !isLandscapemode ? 10 : 0,
               }}
               ListHeaderComponent={
                  !isLandscapemode ? <Header styles={styles} /> : null
               }
               ItemSeparatorComponent={props => {
                  // here you can access the trailingItem with props.trailingItem
                  return <View style={{height: 12}} />;
               }}
               data={
                  Array.isArray(courseModuleSlide)
                     ? courseModuleSlide.slice(0, currentSlideNumber)
                     : [courseModuleSlide]
               }
               renderItem={({item, index, isScrollable}) => (
                  <ModuleSlideItem
                     icon={item.icon}
                     title={
                        isMacOS
                           ? item.SlideName.replace(/\u0013/g, '-')
                           : item.SlideName
                     }
                     index={index}
                     isScrollable={isScrollable}
                  />
               )}
               keyExtractor={item => item.id}
               onSelect={(item, index) => {
                  if (
                     rectifyBooleanString(
                        props.cModuleSlide.isModuleComplete,
                     ) &&
                     rectifyBooleanString(
                        item.courseModuleSlideTestSettings.isFinalTest,
                     )
                  ) {
                     isWeb
                        ? dispatch(
                             setResponseAlertData({
                                showAlert: true,
                                title: 'Alert!',
                                message: 'You have already completed the test.',
                                callbackType: 'GO_BACK',
                             }),
                          )
                        : Alert.alert(
                             'Alert!',
                             'You have already completed the test',
                             [
                                {
                                   text: 'OK',
                                   onPress: () => {
                                      navigation.pop(1);
                                   },
                                },
                             ],
                          );
                     return;
                  }
                  props.onRowSelected(item.id);
                  navigation.navigate('PlayerScreen', {
                     courseModuleID: 0,
                     courseModuleSlide: Array.isArray(courseModuleSlide)
                        ? courseModuleSlide
                        : [courseModuleSlide],
                     index: index,
                     courseData: props.cModuleSlide.courseData,
                     isModuleCompleted: rectifyBooleanString(
                        props.cModuleSlide.isModuleComplete,
                     ),
                     courseTitle: props.cModuleSlide.CourseModuleName,
                  });
               }}
               isLandscapemode={isLandscapemode}
            />
         </View>

         {/** Bottom View Container  */}
         {!isLandscapemode ? (
            <View
               style={[
                  styles.lowerView,
                  !isLandscapemode && {
                     ...Platform.select({
                        web: {
                           position: 'fixed',
                           bottom: 0,
                        },
                     }),
                  },
               ]}>
               <TouchableOpacity
                  style={styles.courseSupportButtonView}
                  onPress={() => {
                     handleCourseSupportAction();
                  }}>
                  <View
                  /* style={{
                        //flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: primaryColor500,
                     }} */
                  >
                     {/* <Text style={styles.buttonTitle}>{'Continue'}</Text> */}
                     <Image
                        source={require('../../assets/blue-continue-btn-portrait.png')}
                        //imageStyle={{borderRadius: 6}}
                        style={{
                           width: '100%',
                           height: 44,
                           borderRadius: 4,
                           //resizeMode: 'contain',
                           //marginHorizontal: 10,
                        }}
                     />
                     {/* <Image
                        source={require('../../assets/continueIcon.png')}
                        style={{
                           width: 18,
                           height: 18,
                        }}
                     /> */}
                  </View>
               </TouchableOpacity>
            </View>
         ) : (
            <View
               style={{
                  //marginVertical: 20,
                  height: 104,
                  flexDirection: 'row-reverse',
                  justifyContent: 'flex-start',
                  marginHorizontal: !isLandscapemode ? 16 : 24,
                  paddingVertical: 24,
                  ...Platform.select({
                     web: {
                        marginHorizontal: 24,
                     },
                  }),
               }}>
               {/** Continue Button Action */}
               <TouchableOpacity
                  onMouseEnter={() => setContinueHover(isHoverEnabled)}
                  onMouseLeave={() => setContinueHover(false)}
                  style={{
                     width: 144,
                     height: 56,
                     borderRadius: 6,
                     backgroundColor: primaryColor500,
                     justifyContent: 'center',
                  }}
                  onPress={() => {
                     handleCourseSupportAction();
                  }}>
                  <View
                     style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: primaryColor500,
                        //backgroundColor: 'red',
                     }}>
                     {/* <Text
                        style={[
                           styles.buttonTitleLandscape,
                           {fontSize: isWeb ? 20 : 16, paddingBottom: 4},
                        ]}>
                        {'Continue'}
                     </Text> */}
                     <Image
                        source={
                           isContinueHover
                              ? require('../../assets/blue-continue-btn-landscape_h.png')
                              : require('../../assets/blue-continue-btn-landscape.png')
                        }
                        style={{
                           width: '100%',
                           height: 56,
                           borderRadius: 4,
                        }}
                     />
                     {/* <Image
                        style={{
                           width: 20,
                           height: 20,
                        }}
                        source={require('../../assets/continueIcon.png')}
                     /> */}
                  </View>
               </TouchableOpacity>

               {/** Back Button Action */}
               <TouchableOpacity
                  onMouseEnter={() => {
                     setDashBoardRoot(false);
                     setBackHover(isHoverEnabled);
                  }}
                  onMouseLeave={() => {
                     setDashBoardRoot(false);
                     setBackHover(false);
                  }}
                  style={styles.backButtonLandscape}
                  onPress={() => {
                     if (Platform.OS === 'windows') {
                        dispatch(setIsEnrolledPageReload(false));
                     }
                     props.navigation.goBack();
                  }}>
                  <View style={styles.continueButtonLandscape}>
                     <Image
                        style={{
                           width: 110,
                           height: 56,
                           ...Platform.select({
                              web: {
                                 width: '100%',
                                 height: '100%',
                              },
                           }),
                        }}
                        source={
                           isBackHover
                              ? require('../../assets/blue-back-btn_h.png')
                              : require('../../assets/blue-backBtn.png')
                        }
                     />
                  </View>
               </TouchableOpacity>
            </View>
         )}
      </View>
   );
};

const style = isLandscapemode =>
   StyleSheet.create({
      container: {
         backgroundColor: 'black',
         flex: 1,
         justifyContent: 'space-between',
      },
      buttonView: {
         backgroundColor: primaryColor500,
         minHeight: 32,
         borderRadius: 6,
         justifyContent: 'center',
      },
      lowerView: {
         width: '100%',
         height: height * 0.085,
         justifyContent: 'center',
         alignItems: 'center',
         backgroundColor: drawerListBackgroundColor,
         ...Platform.select({
            web: {
               minHeight: 74,
            },
         }),
      },
      lowerViewLandscape: {
         width: 230,
         height: height * 0.08,
         marginTop: 20,
         ...Platform.select({
            web: {
               marginBottom: 20,
            },
         }),
      },
      courseSupportButtonView: {
         backgroundColor: isWeb ? null : primaryColor500,
         minHeight: 48,
         borderRadius: 6,
         justifyContent: 'center',
         marginHorizontal: 16,
         paddingHorizontal: 16,
         width: isWeb ? '100%' : width - 32,
      },
      headerContainer: {
         flex: 1,
         justifyContent: 'center',
         alignItems: 'center',
         height: '10%',
      },
      headerTitle: {
         marginHorizontal: 16,
         marginVertical: 15,
         fontSize: 14,
         fontWeight: '600',
         fontFamily: FONT_FAMILY_REGULAR,
         color: 'white',
         textAlign: 'center',
      },
      buttonTitle: {
         color: 'white',
         fontSize: 16,
         fontWeight: '500',
         textAlign: 'center',
         fontFamily: FONT_FAMILY_REGULAR,
         marginHorizontal: 10,
         marginBottom: 5,
      },
      buttonTitleLandscape: {
         color: 'white',
         fontSize: 16,
         fontWeight: '500',
         textAlign: 'center',
         fontFamily: FONT_FAMILY_REGULAR,
         marginRight: 10,
      },
      backButtonLandscape: {
         width: 110,
         height: 56,
         borderRadius: 6,
         backgroundColor: primaryColor500,
         justifyContent: 'center',
         marginRight: 15,
      },
      continueButtonLandscape: {
         width: 110,
         height: 56,
         borderRadius: 6,
         backgroundColor: primaryColor500,
         justifyContent: 'center',
         marginRight: 15,
      },
   });

export default ModuleSlidesView;
